import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import Courses from './components/Courses';
import Course from './components/Course';
//import ScormCourse from './components/ScormCourse';
import ExternalCourses from './components/ExternalCourses';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Courses />} />
        <Route path="/course/:id" element={<Course />} />
        <Route path="/scorm-contents/company/:companyId/:id" element={<ScormCourseWrapper />} />
        <Route path="/external-courses/company/:companyId/:id" element={<ScormCourseWrapper />} />
        {/* Add new route for exteral courses in backend */}
      </Routes>
    </Router>
  );
};

const ScormCourseWrapper = () => {
  const { companyId, id: scormCourseId} = useParams();
  return <ExternalCourses companyId={companyId} scormCourseId={scormCourseId} />;
};

export default App;
